import csTools from "cornerstone-tools";
const BaseBrushTool = csTools.importInternal("base/BaseBrushTool");
const external = csTools.external;
const segmentationUtils = csTools.importInternal("util/segmentationUtils");
import getSquare from "./get-square";
const drawBrushPixels = segmentationUtils.drawBrushPixels;

import renderSquareBrushMixin from "./render-brush-mixins/render-square-brush-mixin";
// Register custom mixin
csTools.register("mixin", "renderSquareBrushMixin", renderSquareBrushMixin);

/**
 * @public
 * @class SquareBrushTool
 * @memberof Tools.SquareBrushTool
 * @classdesc Tool for drawing segmentations on an image.
 * @extends Tools.Base.BaseBrushTool
 */
export class SquareBrushTool extends BaseBrushTool {
  constructor(props = {}) {
    const defaultProps = {
      name: "SquareBrush",
      supportedInteractionTypes: ["Mouse", "Touch"],
      configuration: {},
      mixins: ["renderSquareBrushMixin"],
    };

    super(props, defaultProps);

    this.touchDragCallback = this._paint.bind(this);
  }

  /**
   * Paints the data to the labelmap.
   *
   * @protected
   * @param  {Object} evt The data object associated with the event.
   * @returns {void}
   */
  _paint(evt) {
    const eventData = evt.detail;
    const { rows, columns } = eventData.image;
    const { x, y } = eventData.currentPoints.image;

    if (x < 0 || x > columns || y < 0 || y > rows) {
      return;
    }

    const radius = csTools.getModule("segmentation").configuration.radius;
    const pointerArray = getSquare(
      radius,
      rows,
      columns,
      x,
      y,
      eventData.image.rowPixelSpacing
    );

    const { labelmap2D, labelmap3D, shouldErase } = this.paintEventData;

    // Draw / Erase the active color.
    drawBrushPixels(
      pointerArray,
      labelmap2D.pixelData,
      labelmap3D.activeSegmentIndex,
      columns,
      shouldErase
    );

    external.cornerstone.updateImage(evt.detail.element);
  }
}
